export enum BuildingPeriod {
  Monthly = 'Monthly',
  Annually = 'Annually'
}